












































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ILineItem, ICarJob, IJobDetail, JOB_TYPES, SUB_TYPE } from "@/interfaces";
import { DataTableHeader } from "vuetify";
@Component({})
export default class VehiclesTableComponent extends Vue {
  @Prop({ required: true }) public carJobs!: ICarJob[];
  @Prop({ default: true }) public showAdditionalFields!: boolean;

  public mounted() {
  }

  public expanded = [];
  public headers: DataTableHeader[] = [
    {
      text: "Type",
      value: "type"
    },
    {
      text: "Service Qty",
      value: "qty"
    },
    {
      text: "Wheels",
      value: "wheels"
    },
    {
      text: "Total price",
      value: "price"
    }
  ];

  public headers_loosewheel: DataTableHeader[] = [
    {
      text: "Type",
      value: "type"
    },
    {
      text: "Wheels",
      value: "wheels"
    },
    {
      text: "Total price",
      value: "price"
    }
  ];


  formatDetail(job: ICarJob) {
		var details= job.JobDetails;// IJobDetail[]
    if (details == null || details == undefined) return;
    return details.map(d => {
      let wheels = "";

			if (job.SubType==SUB_TYPE.Vehicle){
				if (d.WheelFR) {
					wheels += wheels ? `, Right Front` : "Right Front";
				}
				if (d.WheelFL) {
					wheels += wheels ? `, Left Front` : "Left Front";
				}
				if (d.WheelBR) {
					wheels += wheels ? `, Right Rear` : "Right Rear";
				}
				if (d.WheelBL) {
					wheels += wheels ? `, Left Rear` : "Left Rear";
				}  
			}

			if (job.SubType==SUB_TYPE.LooseWheel){
				wheels = d.LooseWheelCount.toString();
			}

			
			var  type  = d.ServiceItemName;

      return {
        type: type,
        wheels: wheels,
				qty: d.ServiceQty,
        price: `$ ${d.JobPrice}`
      };
    });
  }

  created() {}

  get formattedItems() {
    return this.carJobs.map((item, i) => {
      return {
        ...item,
        Index: i + 1
      };
    });
  }
}
